const myArticles = [
	() => ({
		date: "Oct 18, 2023",
		title: "ARCH-COMP 2023 Category Report: Falsification",
		description:
			"This report presents the results from the 2023 friendly competition in the ARCH workshop for the falsification of temporal logic specifications over Cyber-Physical Systems. We describe the benchmark models selected to compare the tools and the competition settings and provide background on the participating teams and tools. Finally, we present and discuss our results.",
		keywords: [
			"ARCH 2023 workshop",
			"Falsification category",
			"Metric Temporal Logic (MTL) and Signal Temporal Logic (STL)",
			"Hybrid systems testing and verification",
			"Simulation-based approaches",
			"Benchmark models and requirements",
			"Pacemaker benchmark mode",
		],
		link: "https://easychair.org/publications/paper/wFh9",
		link_text: "Read Publication",
	}),

	() => ({
		date: "9 May 2023",
		title: "Demo Abstract: Analysing CPS Security with Falsification on the Microsoft Flight Simulator",
		description:
			'In the paper titled "Stealthy attacks formalized as STL formulas for Falsification of CPS Security", we investigate a broad class of attacks on the sensor and actuation blocks in the form of additive perturbation that impacts the measurement and control, respectively. In this demo, we demonstrate the usage of our framework and the underlying technologies along with a case study on aviation systems using Microsoft Flight Simulator.',
		keywords: [
			"Security and privacy",
			"Theory of computation",
			"Computing methodologies",
		],
		link: "https://dl.acm.org/doi/abs/10.1145/3575870.3589550",
		link_text: "Read Publication",
	}),

	() => ({
		date: "Oct 31, 2020",
		title: "Simple is better than Complex",
		description:
			"My internship experience at Resilient Tech has been nothing short of incredible. It has not only enhanced my technical skills but also provided me with a deeper understanding of software development from both a business and user perspective. The emphasis on writing high-quality code and the supportive mentorship have been instrumental in shaping my career. This write up summarizes my journey as an intern at Resilient Tech",
		keywords: [
			"Software Developer Internship",
			"Python",
			"ERPNext",
			"Frappe Framework",
			"Mentorship",
			"Professional Growth",
		],
		link: "https://walstanb.medium.com/simple-is-better-than-complex-my-first-internship-experience-at-resilient-tech-af3424d7162e",
		link_text: "Read Post",
	}),
	// Add more articles here if needed
];

export default myArticles;
